import AModal from '@/components/A/AModal/AModal'
import styles from './FreeTrialModal.module.less'
import ApplyTrialBox, { ApplyTrialParam } from '@/components/ApplyTrialBox/ApplyTrialBox'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useTranslation } from 'react-i18next'

interface Props {
  userInfo: Models.UserInfo
  onSubmit: (param: ApplyTrialParam) => void
}

function FreeTrialModal(props: Props) {
  const modal = useModal()
  const { t } = useTranslation()

  const handleSubmit = async (param: ApplyTrialParam) => {
    props.onSubmit(param)
    modal.hide()
  }


  const handleClose = () => {
    modal.hide()
  }

  return <AModal
    testId='free-trial-modal'
    open={modal.visible}
    className={styles.freeTrialModal}
    title={null}
    footer={null}
    onCancel={handleClose}
    afterClose={() => {
      modal.remove()
    }}
  >
    <p className={styles.title}>{t('modals.freeTrialModal.title')}</p>
    <ApplyTrialBox className={styles.applyTrialBox} onSubmit={handleSubmit} userInfo={props.userInfo} />
  </AModal>
}

export default NiceModal.create(FreeTrialModal)
